
import actions from './actions'
export default {
  criarNovoSite: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.clickButton,
    label: 'Criar novo site'
  },
  queroCriarUmSite: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.clickCardselection,
    label: 'Quero criar um site'
  },
  queroTransferirUmSite: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.clickCardselection,
    label: 'Quero transferir um site'
  },
  dominioDoSite: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.enterInput,
    label: 'Domínio do site'
  },
  tituloDoSite: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.enterInput,
    label: 'Título do site'
  },
  eMail: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.enterInput,
    label: 'E-mail'
  },
  usuarioDoWordpress: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.enterInput,
    label: 'Usuário do Wordpress'
  },
  adicionarSenhaDoWordpress: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.enterInput,
    label: 'Adicionar senha do Wordpress'
  },
  confirmarSenhaDoWordpress: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.enterInput,
    label: 'Confirmar senha do Wordpress'
  },
  criarNovoSiteEnviarFormulario: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.clickSubmitButton,
    label: 'Criar Novo site (Enviar formulário)'
  },
  voltarParaLista: {
    página: 'Criar novo site',
    category: '[Lista de sites] Criar novo site',
    action: actions.clickButton,
    label: 'Voltar para lista'
  }
}
